const __WEBPACK_NAMESPACE_OBJECT__ = require("@pmmmwh/react-refresh-webpack-plugin");